import { path } from 'ramda'
import { api } from 'api'

export const getOktaAuthParams = async (email: string) => {
  const data = await api.get(`/okta/${email}/params`)
  return path(['data'], data)
}
